import React from 'react';

const ReactNative = () => {
    return (
        <>
            <div className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb_box text-center">
                                <h2 className="breadcrumb-title">React Native: Cross-Platform Mobile</h2>
                                <ul className="breadcrumb-list">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/technologies">Technologies</a></li>
                                    <li className="breadcrumb-item active">React Native</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="service-details-wrapper section-space--ptb_100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="content-area">
                                <div className="service-details-content">
                                    <h1>React Native: Build Native Apps with JavaScript</h1>
                                    
                                    <p className="lead">React Native enables you to build native mobile applications for iOS and Android using JavaScript. It provides a unified development experience and dramatically reduces time-to-market. Used by Facebook, Instagram, Walmart, Airbnb, and Microsoft.</p>

                                    <h3 className="mt-50">The Power of "Learn Once, Write Anywhere"</h3>
                                    <p>React Native leverages your JavaScript and React knowledge to build native mobile apps. Share logic between iOS and Android while maintaining native performance and user experience.</p>

                                    <h3 className="mt-40">Key Capabilities</h3>
                                    <ul>
                                        <li><strong>Write Once, Deploy Everywhere:</strong> 90% code reuse between iOS and Android</li>
                                        <li><strong>Native Performance:</strong> Direct access to platform APIs for optimal speed</li>
                                        <li><strong>Hot Reloading:</strong> See changes instantly during development</li>
                                        <li><strong>Large Community & Ecosystem:</strong> Thousands of libraries and tools</li>
                                        <li><strong>Access to Native APIs:</strong> Camera, GPS, notifications, and more</li>
                                        <li><strong>Cost-Effective Development:</strong> Single team manages both platforms</li>
                                        <li><strong>Rapid Iteration:</strong> Deploy updates over-the-air</li>
                                        <li><strong>Strong Tooling:</strong> React DevTools, Expo, and more</li>
                                    </ul>

                                    <h3 className="mt-40">Real-World Applications</h3>
                                    <p><strong>Social Media Apps:</strong> Instagram uses React Native for their core app experience.</p>
                                    <p><strong>E-Commerce Apps:</strong> Walmart rebuilt their app using React Native.</p>
                                    <p><strong>Startup MVPs:</strong> Rapid prototyping and launch without native team overhead.</p>

                                    <h3 className="mt-40">AppCore's React Native Success</h3>
                                    <div className="case-study-box mt-30">
                                        <h5>Success: Multi-Platform Marketplace App</h5>
                                        <p>We built a marketplace with React Native:</p>
                                        <ul>
                                            <li>🚀 iOS & Android launched simultaneously</li>
                                            <li>📊 90% code sharing between platforms</li>
                                            <li>⚡ 50% faster development than native</li>
                                            <li>💰 60% cost savings on development</li>
                                        </ul>
                                    </div>

                                    <h3 className="mt-40">Advanced React Native Patterns</h3>
                                    <ul>
                                        <li>Navigation and routing (React Navigation)</li>
                                        <li>State management (Redux, Zustand)</li>
                                        <li>Native modules for custom functionality</li>
                                        <li>Performance optimization techniques</li>
                                        <li>Testing strategies for mobile apps</li>
                                        <li>CI/CD for mobile deployments</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar-area">
                                <div className="sidebar-widget mb-50">
                                    <h5 className="widget-title mb-30">React Native Benefits</h5>
                                    <ul className="sidebar-list">
                                        <li>📱 iOS & Android Support</li>
                                        <li>💻 JavaScript Skills Reuse</li>
                                        <li>⚡ Native Performance</li>
                                        <li>🔄 Hot Reloading</li>
                                        <li>💰 Cost Effective</li>
                                        <li>🚀 Rapid Development</li>
                                    </ul>
                                </div>

                                <div className="sidebar-widget">
                                    <h5 className="widget-title mb-30">Project Stats</h5>
                                    <div className="metric-item mb-20">
                                        <p className="metric-label">React Native Apps</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>30+</p>
                                    </div>
                                    <div className="metric-item mb-20">
                                        <p className="metric-label">Code Reuse</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>90%</p>
                                    </div>
                                    <div className="metric-item">
                                        <p className="metric-label">App Rating</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>4.7/5</p>
                                    </div>
                                </div>

                                <div className="sidebar-widget mt-50">
                                    <h5 className="widget-title mb-30">Industry Choice</h5>
                                    <p className="small">Facebook, Instagram, Airbnb, Walmart, Uber Eats, and Discord use React Native for high-quality mobile experiences.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReactNative;
